<template>
  <div class="d-flex flex-column gap-2">
    <ts-filter-check
      :value="checkboxLocationGermany"
      :count="employmentCount.location_germany"
      :loading="loadingLocationCount"
      :disabled="isLocationFromDropdown"
      @change="onLocationGermanyToggle"
    >
      {{ translations[15918] }}
    </ts-filter-check>
    <ts-filter-check
      :value="checkboxLocationNetherlands"
      :count="employmentCount.location_netherlands"
      :loading="loadingLocationCount"
      :disabled="isLocationFromDropdown"
      @change="onLocationNetherlandsToggle"
    >
      {{ translations[15919] }}
    </ts-filter-check>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { ProfessionModule } from '@/store/modules/profession';
import { ICountType } from '@/types/ProfessionType';
import TsFilterCheck from '@/components/Talentspace/filters/TsFilterCheck.vue';

@Component({
  components: { TsFilterCheck },
})
export default class LocationCountryFilter extends Vue {
  @Prop({ default: false }) loadingLocationCount!: boolean;

  get translations() {
    return AppModule.translation;
  }

  get employmentCount(): ICountType {
    return ProfessionModule.employmentCount;
  }

  get isLocationFromDropdown() {
    const id = ProfessionModule.jobSearch.location_id;
    if (!id) return false;
    return +id !== 1206 && +id !== 1227;
  }

  get checkboxLocationGermany() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1206;
  }

  get checkboxLocationNetherlands() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1227;
  }

  onLocationGermanyToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationGermany;
    const newLocation = currentlyOn ? { id: 1227, name: this.translations[15919] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.$emit('search'));
  }

  onLocationNetherlandsToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationNetherlands;
    const newLocation = currentlyOn ? { id: 1206, name: this.translations[15918] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.$emit('search'));
  }
}
</script>
